import { render, staticRenderFns } from "./ListPendingRequestPage.vue?vue&type=template&id=79e32873"
import script from "./ListPendingRequestPage.vue?vue&type=script&lang=js"
export * from "./ListPendingRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports